import template from './pdp-add-to-cart.html';
export default template;
